import { Link } from "react-router-dom";

import styled from "@emotion/styled";
import { Card, CardContent } from "@mui/material";

const CardStyled = styled(Card, {
  shouldForwardProp: prop =>
    prop !== "addStyles" && prop !== "cardBackground" && prop !== "addPadding",
})`
  height: auto;
  width: 100%;
  border-radius: 20px;
  box-shadow: none;
  background-color: ${props => props.cardBackground};

  ${props => props.addStyles};
    
    @media screen and  (min-width: ${p => p.theme.screenSizes.lgMin}) {
        max-width: ${p => (p.fullwidth ? "none" : "380px")};
        //max-height: ${p => (p.fixheight ? "251px" : "313px")};
        max-height: ${p => (p.fixheight ? "251px" : "auto")};
        height: 100%;
    }}

`;

const CardContentStyled = styled(CardContent)`
  display: flex;
  flex-direction: column;

  min-height: ${p => (p.mainpage ? 260 : "")}px;
  padding: ${p => (p.changepadding ? "24px" : "28px 24px 23px 24px")};

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    min-height: ${p => (p.mainpage ? 251 : "")}px;
    padding: ${p =>
      p.changepadding ? "36px !important" : "24px 24px 23px 24px !important"};
  }
`;

const Title = styled.h2`
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 500;
  line-height: normal;
  color: ${props => props.titleColor};

  max-width: ${({ getshorter }) => (getshorter ? "20ch" : "100ch")};
  overflow: ${({ getshorter }) => (getshorter ? "hidden" : "")};
  text-overflow: ${({ getshorter }) => (getshorter ? "ellipsis" : "")};
  white-space: ${({ getshorter }) => (getshorter ? "nowrap" : "")};

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    font-size: ${p =>
      p.changesize ? p.theme.fontSizes.xsl : p.theme.fontSizes.xl};
  }
`;

const Text = styled.p`
  font-size: ${p => p.theme.fontSizes.s};
  line-height: 150%;

  color: ${props => props.descriptionColor};

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
`;

const BoxIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ iconBackground }) => iconBackground};

  height: 48px;
  width: 48px;
  margin-bottom: 49px;
  border-radius: 50%;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    height: 60px;
    width: 60px;

    margin-bottom: 48px;
  }
`;

const StyledLink = styled(Link)`
  -webkit-tap-highlight-color: transparent;

  display: flex;
  width: fit-content;

  gap: ${p => p.theme.space[3]}px;
  margin-top: ${p => (p.blog ? "20px" : "auto")};
  padding: ${p => (p.blog ? "12px 16px" : "5px 12px")};

  background-color: ${({ buttonbackground }) => buttonbackground};
  text-decoration: none;
  font-size: ${p => p.theme.fontSizes.m};
  color: ${({ buttoncolor }) => buttoncolor};
  border-radius: ${({ blog, theme }) => (blog ? theme.radii.medium : "7px")};

  transition: background-color 0.3s ease-in-out;

  :hover {
    background-color: ${({ buttonhover }) => buttonhover};
  }

  :active {
    background-color: ${({ buttonactive }) => buttonactive};
  }

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-top: ${p => (p.blog ? "28px" : "auto")};
  }
`;

export { CardStyled, CardContentStyled, Title, Text, BoxIcon, StyledLink };
